import { IConfiguration } from '../models/app/IConfiguration';

export const CONFIGURATION: IConfiguration = {
	commonData: {
		data: {
			code: 'scatter_test',
			entityType: 'CLSS',
			queryOptionsType: 'allocations',
		},
	},
	components: {
		app: {
			cardProps: {
				props: {
					subtitle: 'Scatter App subtitle title',
					title: 'Scatter App title',
				},
			},
			gridProps: {
				grid: {
					rows: [
						{
							columns: [
								{
									components: [
										{
											key: 'app.chart',
										},
									],
								},
							],
						},
					],
					style: {
						overrides: [
							{
								selector: 'section[data-selector="base-grid-column"]',
								style: {
									width: '100%',
								},
							},
						],
					},
				},
			},
		},
		chart: {
			chartProps: {
				composedChartProps: {
					height: 400,
					margin: {
						bottom: 20,
						left: 20,
						right: 20,
						top: 20,
					},
					width: 500,
				},
				elementOverrides: {
					legend: {
						align: 'right',
						layout: 'vertical',
						verticalAlign: 'top',
					},
					tooltip: {
						cursor: {
							strokeDasharray: '3 3',
						},
						hide: false,
					},
					xAxis: {
						label: {
							position: 'bottom',
						},
						labelQuery: {
							code: 'fund_name',
							entityType: 'CLSS',
							queryOptionsType: 'property',
						},
						axisLine: false,
						persistQuadrants: true,
						useMeanTickPivotPoint: true,
					},
					yAxis: {
						label: {
							angle: -90,
							position: 'insideLeft',
						},
						labelQuery: {
							code: 'fund_nick_name',
							entityType: 'CLSS',
							queryOptionsType: 'property',
						},
						axisLine: false,
						persistQuadrants: true,
						useMeanTickPivotPoint: true,
					},
				},
				ascendingDiagonalReferenceLine: { stroke: 'grey' },
				xPivotReferenceLine: {
					stroke: 'black',
					label: {
						position: 'insideTopRight',
						offset: 35,
						className: "xpivot-label"
					},
					labelQuery: {
						code: 'public_share_class_name',
						entityType: 'CLSS',
						queryOptionsType: 'property',
					},
				},
				yPivotReferenceLine: {
					stroke: 'black',
					label: {
						position: 'insideTopRight',
						offset: 30,
						className: "ypivot-label"
					},
					labelQuery: {
						code: 'ccy',
						entityType: 'CLSS',
						queryOptionsType: 'property',
					},
				},
				highlightDataPointProps: {
					key: 'rate_of_return',
					valueQuery: {
						queryOptionsType: 'none',
						value: 40,
					},
					fillColor: 'green',
					size: 20,
					borderColor: 'black',
					borderWeight: 2,
				},
				highLowBubbleChartProps: {
					highColors: [
						'#00004d',
						'#000099',
						'#0000ff',
						'#4d4dff',
						'#b3b3ff',
						'red',
					],
					highLowKey: 'contribution',
					highLowValue: 5,
					lowColors: ['#660000', '#b30000', '#ff0000', '#ff6666', '#ffb3b3'],
					maxDotSize: 30,
					midBubbleBorderColor: 'blue',
					midBubbleBorderWeight: 1,
					midBubbleColor: 'yellow',
					minDotSize: 5,
					showDataInLegend: true,
					legendDataFormatter: {
						type: "number",
						options: {
							maximumFractionDigits: 2,
							minimumFractionDigits: 2,
						}
					},
					xDatakey: 'rate_of_return',
					xLabel: 'Rate of Return',
					yDatakey: 'contribution',
					yLabel: 'Contribution',
					zDatakey: 'average_weight',
					zLabel: 'Average Weight',
				},
			},
		},
		customTooltip: {
			headerTemplate: {
				conditions: [
					{
						conditional: {
							conditions: [
								{
									field: 'weight',
									operator: '=',
									value: 0,
								},
								{
									field: 'weight',
									operator: 'undefined',
								},
							],
							format: '{1} OR {2}',
						},
						value: '{label}',
					},
				],
				default: '{label} ({weight})',
			},
			itemTemplate: {
				default: '{name}: {value}',
			},
			useCustomTooltip: true,
		},
	},
	data: {
		context: {
			entityByType: {
				CLSS: {
					clientCodeProperty: 'isin',
					include: {
						allocations: {},
					},
					inputKey: 'isin',
				},
			},
			globalDisclaimers: [
				{
					global: true,
				},
			],
		},
	},
};
